export default __webpack_public_path__ + "static/media/MP0019.e10014a4.jpg";